module.exports = __webpack_public_path__ + "img/up.679f85c4.svg";